import { css } from '@emotion/core';
import { tokens, media, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var cardContainer = /*#__PURE__*/css("width:100%;min-height:120px;margin-bottom:20px;border:1px solid ", colors.neutral.trim.default, ";position:relative;padding:16px;&:hover{box-shadow:0 5px 40px 0 ", colors.neutral.trim.default, ";}");
export var nameContainer = /*#__PURE__*/css("display:flex;flex-direction:column;vertical-align:top;", media('>=tablet'), "{flex-direction:row;}");
export var detailsColumn = /*#__PURE__*/css("width:100%;", media('>=tablet'), "{width:70%;}");
export var rightIcon = /*#__PURE__*/css("display:none;padding-right:40px;", media('>=tablet'), "{display:inline-block;}");
export var rightIconMobile = /*#__PURE__*/css("display:inline-block;float:right;", media('>=tablet'), "{display:none;}");
export var placeholder = {
  name: "5wy4gk",
  styles: "max-width:135px;"
};
export var logoContainer = {
  name: "13dcbvq",
  styles: "display:inline-block;width:150px;margin-bottom:15px;"
};
export var avatarContainer = {
  name: "1eqg989",
  styles: "display:inline-block;width:125px;"
};
export var avatar = {
  name: "tormeg",
  styles: "display:inline-block;width:96px;height:96px;"
};
export var img = {
  name: "17ib58w",
  styles: "border-radius:50%;width:96px;height:96px;overflow:hidden;object-fit:cover;"
};
export var cardDetails = /*#__PURE__*/css("display:block;", media('>=tablet'), "{display:inline-block;}");
export var logo = /*#__PURE__*/css("display:none;margin-bottom:12px;", media('>=tablet'), "{display:inline-block;}");
export var logoMobile = /*#__PURE__*/css("display:inline-block;vertical-align:top;", media('>=tablet'), "{display:none;}");
export var cardName = /*#__PURE__*/css("padding-bottom:12px;color:", colors.neutral.heavy.default, ";", applyFont(typography.heading));
export var agentStaffName = /*#__PURE__*/css("padding-bottom:12px;margin-top:15px;color:", colors.neutral.heavy.default, ";", applyFont(typography.heading), " ", media('>=tablet'), "{margin-top:0;}");
export var jobTitle = /*#__PURE__*/css("padding-bottom:12px;", applyFont(typography.body), " line-height:", typography.mini.lineHeight, ";color:", colors.neutral.medium.default, ";");
export var agentName = /*#__PURE__*/css("padding-bottom:12px;", applyFont(typography.body), " line-height:", typography.mini.lineHeight, ";color:", colors.neutral.medium.default, ";");
export var cardAnchor = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";text-decoration:none;&::before{position:absolute;top:0;right:0;left:0;bottom:0;z-index:2;content:'';}");
export var cardAddress = /*#__PURE__*/css("display:inline-block;", applyFont(typography.body), " color:", colors.neutral.medium.default, ";margin-bottom:16px;");
export var awardPill = withMargin => /*#__PURE__*/css("margin:", withMargin ? '10px 0' : '0', ";");